import utils from 'utils';
import {api} from '@/api';
import {useEffect, useState} from 'react';

import {
    Header,
    ReportDetail,
    ReportSidePanel,
} from '@components/export';

export const ReportPage = () => {
    const [reportData, setReportData] = useState(null);
    const [currentDate, setCurrentDate] = useState(null);
    const [productName, setProductName] = useState('');

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (currentDate) {
            setLoading(true);

            api.panas.getProductsStatsByMonth(new Date(currentDate))
                .then((res) => {
                    setReportData(res.data);
                    setProductName('');
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [currentDate]);

    return <>
        <Header/>

        <div className={'page-content ' + cmpClass}>
            <div className={classMap.wrapper}>
                <ReportSidePanel
                    reportData={!loading ? reportData : null}
                    onProductSelect={setProductName}
                    onSearch={setCurrentDate}
                />
                <ReportDetail
                    reportData={reportData}
                    currentDate={currentDate}
                    productName={productName}
                    loading={loading}
                />
            </div>
        </div>
    </>;
};

const cmpClass = 'report-page';
const classMap = utils.generateClassMap(cmpClass, {
    wrapper: 'wrapper',
});
